import { render } from "./ScenarioAccordion.vue?vue&type=template&id=bfbeb8a8&scoped=true"
import script from "./ScenarioAccordion.vue?vue&type=script&lang=js"
export * from "./ScenarioAccordion.vue?vue&type=script&lang=js"

import "./ScenarioAccordion.vue?vue&type=style&index=0&id=bfbeb8a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfbeb8a8"]])

export default __exports__